import React, { useState, useEffect } from 'react';

import './PropertySlider.css'; 

const truncateTitle = (title, wordLimit = 4) => {
  const words = title.split(' ');
  return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : title;
};

const decodeHtmlEntities = (html) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const ViewMoreProperty = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(100);
  const [totalPage, setTotalPage]=useState(1);

  // Replace your current useEffect with:
useEffect(() => {
  const fetchProperties = async () => {
    try {
      const res = await fetch(
        `https://pp-backend-1-sa8p.onrender.com/properties` 
      );
      const data = await res.json();
      console.log(data.length);
      setTotalPage(Math.ceil(data.length / 6));
      setProperties(data); 
    } catch (err) {
      console.error('Error fetching properties:', err);
    } finally {
      setLoading(false);
    }
  };
  fetchProperties();
}, []); 

  const indexOfLast = currentPage * pageSize;
  const indexOfFirst = indexOfLast - pageSize;
  const currentProperties = properties.slice(indexOfFirst, indexOfLast);

  const nextPage = () => {
    if (indexOfLast < properties.length) setCurrentPage(prev => prev + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(prev => prev - 1);
  };

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <div className="loading-spinner"></div>
    </div>
  );

  return (
    <div className="property-slider">
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>All Properties</h2>
      <div 
        className="property-grid"
        style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '20px',
            padding: '20px'
        }}
      >
        {currentProperties.map((property) => (
          <div key={property._id} className="property-card-wrapper">
            <div className="property-card">
              <a href={`/property/${property.slug || property._id}`} target="_blank" rel="noopener noreferrer">
                <img
                  src={
                    property.propertyImages?.[0]?.url || 'https://via.placeholder.com/400'
                  }
                  alt={property.title}
                  className="property-image"
                  //loading="lazy"
                />
                <div className="property-details">
                  <h3 className="property-title">{truncateTitle(decodeHtmlEntities(property.title))}</h3>
                  <div className="property-meta">
                    <p className="property-size">
                      {property.size ? `${property.size} sq. ft.` : 'Size not available'}
                    </p>
                    <p className="property-possession">
                      {property.possessionDate ? `Possession: ${property.possessionDate}` : 'Possession not available'}
                    </p>
                  </div>
                </div>
                <div className="property-footer">
                  <p className="property-price">
                    {property.price ? `₹ ${property.price} ${property.propertyLabel || ''}` : 'Price on request'}
                  </p>
                  <button className="contact-now-button">Contact Now</button>
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button onClick={prevPage} disabled={currentPage === 1} className="pagination-button">
          ← Previous
        </button>
        <span style={{ margin: '0 15px' }}>Page {currentPage} of {totalPage}</span>
        <button 
            onClick={nextPage} 
            disabled={properties.length < pageSize} 
            className="pagination-button"
        >
            Next →
        </button>
      </div>
    </div>
  );
};

export default ViewMoreProperty;
